import * as v from "valibot";

export const ComponentTypeEnum = v.picklist(["KUBELET", "CONTAINERD"]);
export type ComponentType = v.InferOutput<typeof ComponentTypeEnum>;

export const ParamTypeEnum = v.picklist(["int32", "int64", "string", "boolean", "enum", "duration", "map"]);
export type ParamType = v.InferOutput<typeof ParamTypeEnum>;

export const ParamSpecSchema = v.object({
  Name: v.string(),
  Type: ParamTypeEnum,
  Default: v.optional(v.string()),
  Min: v.optional(v.number()),
  Max: v.optional(v.number()),
  EnumValues: v.optional(v.array(v.string())),
});
export type ParamSpec = v.InferOutput<typeof ParamSpecSchema>;

export const ComponentDefaultParamsSchema = v.object({
  Type: ComponentTypeEnum,
  Params: v.array(ParamSpecSchema),
});
export type ComponentDefaultParams = v.InferOutput<typeof ComponentDefaultParamsSchema>;

// request
export const RequestSchema = v.object({
  K8sVersion: v.string(),
  ComponentType: v.optional(ComponentTypeEnum),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const DataSchema = v.object({
  K8sVersion: v.string(),
  ComponentDefaultParams: v.array(ComponentDefaultParamsSchema),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
